"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = require("react");
var _logger = require("../../logger");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const localLogger = _logger.mainLogger.createChild('Icon');
/**
 * Dynamically imports the icon component based on the iconName prop and renders it.
 * Icon can be chosen from https://storybook.oriflame.com/?path=/story/icons-overview--overview.
 */
const Icon = ({
  iconName,
  ...props
}) => {
  // eslint-disable-next-line react/hook-use-state -- Need value to start with capital letter
  const [IconComponent, setIconComponent] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const loadIcon = async () => {
      const module = await Promise.resolve().then(() => _interopRequireWildcard(require('@ori-ui/icons')));
      const component = module[iconName];
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- If user specifies wrong name we can get undefined here.
      if (component == null) {
        localLogger.warn(`Icon with name "${iconName}" not found.`);
      } else {
        setIconComponent(component);
      }
    };
    void loadIcon();
  }, [iconName]);
  if (!IconComponent) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
    ...props
  });
};
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map